<template>
<div>
  <el-row class="title-bar" type="flex" justify="space-between">
    <div class="vertical-center-box">
      <div class="title-h3">{{selectedTitle}}</div>
      <div class="setting-addel mr-l15">
        <el-button size="mini" @click="addScriptSetting"><i class="fas fa-plus"></i></el-button>
        <el-button size="mini" :disabled="!isCheckList" @click="deleteScriptSetting"><i class="fas fa-minus"></i></el-button>
      </div>
    </div>
    <div>
      <w-header-search-button @click="showSearchTool = !showSearchTool"></w-header-search-button>
    </div>
  </el-row>
  <el-table-wrapper ref="scriptSettingTable" slot="body" :data="dataList" @row-dblclick="editScriptSetting" row-class-name="c-dblclick"
  :column-default="columnDefault" @condition-change="onTableConditionChange" :total="total" remote pagination
   @selection-change="scriptChangeSelection" :columns="scriptColumns" :show-custom-header="true"
  :show-search-tool="showSearchTool" style="width:100%;">
    <template slot-scope="scope" slot="testButton">
      <i class="fas fa-play-circle text-14 c-pointer" @click="testScriptSetting(scope.row)"/>
    </template>
  </el-table-wrapper>
  <w-script-setting-popup ref="scriptSettingPopup" @reload-data="reloadScriptList" :activeCompanyId="activeCompanyId" :editRow="editRow" :templateTypeList="templateTypeList" :popup-type="scriptPopupType"></w-script-setting-popup>
  <w-script-test-popup ref="scriptTestPopup" :activeCompanyId="activeCompanyId" :editRow="editRow" ></w-script-test-popup>
</div>
</template>

<script>
import { clone, cloneDeep } from 'lodash';
import { columnDefault } from '@/constants/table';
import { getValueAfterCheckEmpty } from '@/utils/string';
import msgUtil from '@/utils/message';
import NetdeviceSettingAPI from '@/api/settings/netdevice/netdevice-settings';
import WScriptSettingPopup from '@/views/settings/netdevice/ScriptSettings/popup/ScriptSettingPopup';
import WScriptTestPopup from '@/views/settings/netdevice/ScriptSettings/popup/ScriptTestPopup';

export default {
  name: 'WScriptSettingList',
  components: {
    WScriptSettingPopup,
    WScriptTestPopup,
  },
  props: {
    dataList: {
      type: Array,
      default: () => [],
    },
    selectedTitle: String,
    templateTypeList: {
      type: Array,
      default: () => [],
    },
    activeCompanyId: Number,
    total: {
      type: Number,
    },
  },
  data() {
    return {
      columnDefault,
      scriptPopupType: '',
      showSearchTool: false,
      isCheckList: false,
      changeScriptList: [],
      editRow: {},
      scriptColumns: [
        {
          align: 'center',
          type: 'selection',
        },
        {
          prop: 'templateName',
          width: 300,
          label: '스크립트명',
          remoteProp: 'nt.template_name',
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'templateDescr',
          label: '설명',
          sortable: true,
          remoteProp: 'nt.template_descr',
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          prop: 'script',
          label: '스크립트',
          showOverflowTooltip: true,
          sortable: true,
          searchable: true,
          formatter: this.getTableValueAfterCheckEmpty,
        },
        {
          width: 110,
          prop: 'scriptTest',
          label: '스크립트 테스트',
          scopedSlot: 'testButton',
          align: 'center',
        },
      ],
    };
  },
  watch: {},
  methods: {
    reloadScriptList() {
      this.$emit('reload-data');
    },
    getTableValueAfterCheckEmpty(row, column, value) {
      return getValueAfterCheckEmpty(value);
    },
    scriptChangeSelection(selectVal) {
      this.changeScriptList = selectVal;
      if (this.changeScriptList.length > 0) {
        this.isCheckList = true;
      } else {
        this.isCheckList = false;
      }
    },
    /**
     * [addScriptSetting  설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 항목을 추가한다.]
     * @author yelim
     */
    addScriptSetting() {
      this.editRow = {};
      this.scriptPopupType = 'ADD';
      this.$refs.scriptSettingPopup.open();
    },
    /**
     * [editScriptSetting  설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 항목을 수정한다.]
     * @author yelim
     */
    editScriptSetting(row) {
      this.editRow = cloneDeep(row);
      this.scriptPopupType = 'EDIT';
      this.$refs.scriptSettingPopup.open();
    },
    testScriptSetting(row) {
      this.editRow = clone(row);
      this.$refs.scriptTestPopup.open();
    },
    /**
     * [deleteScriptSetting  설정 > 네트워크 설정 > 스트립트 설정에서 스크립트 항목을 삭제한다.]
     * @author yelim
     */
    deleteScriptSetting() {
      if (this.changeScriptList.length > 0) {
        this.$confirm(...msgUtil.getBasicConfirmData(msgUtil.action.DELETE)).then(() => {
          NetdeviceSettingAPI.deleteNcmTemplateCompany(this.changeScriptList).then((response) => {
            if (response.data.success) {
              this.$emit('reload-data');
            }
            this.$message(msgUtil.getResultMsgData(msgUtil.action.DELETE, '스크립트', response.data.success));
          });
        });
      }
    },
    onTableConditionChange() {
      this.reloadScriptList();
    },
  },
};
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/views/settings/netdevice/ScriptSettings/component/ScriptSettingList.vue